import { ImageContent } from '@/store/modules/image/types';
import { Content, Frame } from '@forchange/storytime';

import PhotoSwipe from 'photoswipe';
// @ts-ignore
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import 'photoswipe/dist/photoswipe.css';

class ImageViewer {
  vm: Vue;
  hook: Function;
  runnerHook: Function;
  lightbox: PhotoSwipeLightbox;
  isRunner: boolean;

  constructor(vm: Vue, isRunner?: boolean) {
    this.vm = vm;
    this.isRunner = !!isRunner;

    this.hook = (currentData: {
      content: Content & { url: string; portalSequence: Frame };
      frame: Frame;
    }) => {
      if (currentData.frame.$kind !== 'Dialog' || currentData.content?.$kind !== 'Image') return;

      this.pushSource({
        $id: currentData.content.$id,
        $kind: currentData.content.$kind,
        url: currentData.content.url
      });
    };

    this.runnerHook = (params: any) => {
      const value = params.params;
      if (!value) return;
      if (value?.$kind !== 'Portal' || !value.portalSequence) return;
      const sequence = value.portalSequence as Frame;
      this.setPortalImage(sequence);
    };

    window.storyteller.addHook(this.hook, 'AFTER_NEXT');
    if (this.isRunner) window.storyteller.addHook(this.runnerHook, 'RUNNER_NEXT');
    this.initViewer();
  }

  static init(vm: Vue, isRunner?: boolean) {
    return new ImageViewer(vm, isRunner);
  }

  initViewer() {
    this.lightbox = new PhotoSwipeLightbox({
      dataSource: [],
      pswpModule: () => PhotoSwipe,
      preloaderDelay: 0,
      closeTitle: '关闭',
      zoomTitle: '缩放',
      arrowPrevTitle: '上一张',
      arrowNextTitle: '下一张',
      mainClass: 'pswp--custom-bg',
      secondaryZoomLevel: 2,
      maxZoomLevel: 5
    });

    this.lightbox.addFilter('contentErrorElement', () => {
      const el = document.createElement('div');
      el.className = 'flex flex-col items-center justify-center';
      el.innerHTML = `<img src="${require('./assets/error.png')}" width=50 height=50><span style="color: #FFF;margin-top: 10px;">图片加载失败</span>`;
      return el;
    });

    this.lightbox.on('contentLoadImage', (image: any) => {
      const imageEl = image.content.element as HTMLImageElement;
      imageEl.setAttribute('oncontextmenu', 'return false;');
    });
  }

  open() {
    if (!this.lightbox) {
      throw new Error('请先调用init创建实例');
    }
    this.lightbox.loadAndOpen(0);
  }

  pushSource(pushSource: ImageContent) {
    const { options } = this.lightbox;
    this.vm.$store.commit('images/setImage', pushSource);
    try {
      this.lightbox.options.dataSource.push({
        src: pushSource.url,
        width: 800,
        height: 800
      });
    } catch (error) {
      console.log('error: ', error);
    }
  }

  updateHook() {
    if (!this.isRunner) return;
    this.isRunner = false;
    window.storyteller.addHook(this.hook, 'AFTER_NEXT');
  }

  setPortalImage(portalSequence: Frame) {
    if (portalSequence?.$kind !== 'Dialog') return;
    (
      portalSequence as unknown as {
        contents: Array<Content & { url: string; portalSequence: Frame }>;
      }
    ).contents.forEach((content) => {
      if (content.$kind === 'Portal') this.setPortalImage(content.portalSequence);
      if (content.$kind === 'Image') {
        const insertData = {
          $id: content.$id,
          $kind: content.$kind,
          url: content?.url || ''
        };
        this.pushSource(insertData);
      }
    });
  }
}

export default ImageViewer;
